import { AxiosResponse } from 'axios';

import { axiosIntance } from '../../../config/ApiConfig';
import {
  Pin,
  PinResponse,
  UserAttendanceDTO,
  ResponseAttendance,
} from 'src/types/users/User';

export const UserRepository = {
  create: (form: object) => {
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };

    return axiosIntance.post(`/users`, form, config);
  },
  delete: (data: any) => {
    return axiosIntance.delete(`/users`, { data: { id: data._id, ...data } });
  },
  update: (form: object) => {
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };
    return axiosIntance.put(`/users`, form, config);
  },
  recoveryPasswordStep1: (email: string) => {
    return axiosIntance.post(`/auth/password/recovery/step1`, { email });
  },
  recoveryPasswordStep2: (data: object) => {
    return axiosIntance.post(`/auth/password/recovery/step2`, { ...data });
  },
  updateProfile: (form: object) => {
    return axiosIntance.put(`/users/profile`, form);
  },
  changePassword: (form: object) => {
    return axiosIntance.post(`/auth/password/change`, form);
  },
  passwordRecoveryStep1: (email: string) => {
    return axiosIntance.post(`/auth/password/recovery/step1`, { email });
  },
  passwordRecoveryStep2: (data: object) => {
    return axiosIntance.post(`/auth/password/recovery/step2`, { ...data });
  },
  attendanceCheck: (
    data: UserAttendanceDTO
  ): Promise<AxiosResponse<ResponseAttendance>> => {
    return axiosIntance.post(`/users/attendance-check`, { ...data });
  },
  validatePin: (data: Pin): Promise<AxiosResponse<PinResponse>> => {
    return axiosIntance.post('/users/check-security-code', data);
  },
};
